import { noop } from 'lodash';
import { useEffect, useRef, useState } from 'react';

function getDefaultPosition() {
  const height = 600;
  const width = 600;
  const TOP_POS = window.innerHeight / 2 - height / 2;
  const LEFT_POS = window.innerWidth / 2 - width / 2 - 100;
  return { x: LEFT_POS, y: TOP_POS };
}

const DEFAULT_POSITION = getDefaultPosition();

function AppointmentFloaterPositionHook({
  deps = [],
  onMouseDown = noop,
  onMouseMove = noop,
  onMouseUp = noop,
  onClick = noop
}) {
  const initialPositionRef = useRef();
  const [position, setPosition] = useState(() => getDefaultPosition());
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    setPosition(getDefaultPosition());
  }, [window.innerHeight, window.innerWidth]);
  const ref = useRef(null);
  const parentRef = useRef(null);
  const isDraggingRef = useRef(false);
  const clickTimeRef = useRef();

  useEffect(() => {
    if (ref.current == null) return undefined;
    if (parentRef.current === null) return undefined;
    const targetEl = ref.current;
    // const parentEl = parentRef.current;

    function handleMouseDown(e) {
      clickTimeRef.current = new Date();

      onMouseDown(e, position);
      const { left, top, right } = targetEl.getBoundingClientRect();
      initialPositionRef.current = {
        x: e.clientX - left,
        y: e.clientY - top + 20
      };
      if (targetEl.contains(e.target)) {
        isDraggingRef.current = true;
        setIsDragging(true);
      }
    }

    function handleMouseUp(e) {
      onMouseUp(e, position);
      isDraggingRef.current = false;
      setIsDragging(false);
    }

    function handleMouseMove(e) {
      if (!isDraggingRef.current) return;
      const { x, y } = initialPositionRef.current;
      if (e.clientY < 50 || e.clientY > window.innerHeight - 50) return;
      onMouseMove(e, position);
      const left = e.clientX - x;
      const top = e.clientY - y;
      setPosition({ x: left, y: top });
    }

    // function onMouseLeave(e) {
    //   isDraggingRef.current = false;
    // }

    function _onClick(e) {
      // click event will fire right after mousedown and mouseup, to prevent that we are checking the clicktime
      if (new Date() - clickTimeRef.current < 300) {
        e, position;
      }
    }

    targetEl.addEventListener('click', _onClick, true);
    document.addEventListener('mousedown', handleMouseDown);
    window.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('mousemove', handleMouseMove);
    // parentEl.addEventListener('mouseleave', onMouseLeave);

    return () => {
      targetEl.removeEventListener('click', _onClick);
      document.removeEventListener('mousedown', handleMouseDown);
      window.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('mousemove', handleMouseMove);
      // parentEl.removeEventListener('mouseleave', onMouseLeave);
    };
  }, [onMouseDown, onMouseMove, onMouseUp, onClick, position, ...deps]);
  return {
    position,
    setPosition,
    ref,
    parentRef,
    isDragging
  };
}

export { AppointmentFloaterPositionHook, DEFAULT_POSITION };
